import { Context } from "common/types/context";
import { SchedulerFilter } from "common/types/scheduler-filters";
import { classNames } from "common/utils/jsx";
import { ReactHighlightWords } from "common/vendor-wrappers/react-highlight-words";
import { isGroupedOption } from "common/vendor-wrappers/react-select/functions";
import {
  FormatMeta,
  LabelledOption,
  LabelledOptionOrGroup,
} from "common/vendor-wrappers/react-select/types";
import { isSchedulerFilterValid } from "x/scheduler2/planner/work-orders/configuration/functions";

const getClassName = (isChanged: boolean) =>
  classNames([
    "x-select-item x-filter-label",
    isChanged ? "x-filter-changed" : undefined,
  ]);

const getLabel = (
  option: LabelledOption<SchedulerFilter>,
  isChanged: boolean,
) => (isChanged ? `${option.label} *` : option.label);

const getBadge = (context: Context, option: LabelledOption<SchedulerFilter>) =>
  !isSchedulerFilterValid(context, option.value) ? (
    <span className="badge badge-error x-badge pull-right">{_("Invalid")}</span>
  ) : option.value.shared ? (
    <span className="badge badge-secondary x-badge pull-right">
      {_("Shared")}
    </span>
  ) : undefined;

export const getFormatOptionFn =
  (context: Context, changedFilter?: SchedulerFilter) =>
  (
    option: LabelledOptionOrGroup<SchedulerFilter>,
    meta: FormatMeta<SchedulerFilter>,
  ) => {
    if (isGroupedOption(option)) return <>option.label</>;

    const isChanged = changedFilter?.id === option.value.id;
    const className = getClassName(isChanged);
    const label = getLabel(option, isChanged);
    const badge = getBadge(context, option);

    return (
      <div className={className}>
        <ReactHighlightWords text={label} search={meta?.inputValue} />
        {badge}
      </div>
    );
  };

export const getOptionValue = (option: LabelledOption<SchedulerFilter>) =>
  option.value?.id.toString();

export const getFilterLabel = (filter: SchedulerFilter) => filter?.name;
